import React from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import PharmacyProfileSidebar from "../Components/PharmacyProfileSidebar";
import { consultantmage, imgpharmacy, patientdetail } from "../Constant/Index";

const PrescriptionOrdersall = () => {
	return (
		<>
			<Header />
			<PageHeader pagename="Physician Profile" />
			<section className="main-sidebar user-profile">
				<div className="container">
					<div className="row">
						<div className="col-lg-4">
							<PharmacyProfileSidebar />
						</div>

						<div className="col-lg-8">
							<div className="main-profile-content  radius-20 p-5">
								<div className="col-lg-7">
									<div className="main-headind d-flex align-items-center 	gap-3 mb-3">
										<div class="edit-btn back">
											<Link to="/">
												<div class="nav-anchor">
													<i class="fa-solid fa-arrow-left"></i>
												</div>
											</Link>
										</div>
										<h5 class="main-heading level-6 main-heading-font dark-color mb-0 wow animate__animated animate__zoomIn animate__delay-1s ">
											Prescription Orders
										</h5>
									</div>
								</div>
								<div className="main-profile-content  radius-20 p-5">
									<div className="row  border-bottom mb-4 pb-4 ">
										<div className="col-lg-12">
											<div className="d-flex align-items-center gap-5">
												<div className="d-flex gap-3 align-items-center">
													<img
														src={consultantmage}
														className="img-fluid"
														alt=""
													/>
													<div>
														<h4 class="main-heading-font level-6 ">
															Dr. David Patel{" "}
														</h4>
														<h5 class="primary-medium-font level-8 extra-color-15">
															Physician
														</h5>
													</div>
												</div>
												<div className="d-flex align-items-center gap-3">
													<div className="dropdown main-dropdown">
														<a
															className="click-dropdown  black-complete dropdown-toggle1"
															href="#"
															role="button"
															id="dropdownMenuLink"
															data-bs-toggle="dropdown"
															aria-expanded="false"
														>
															<span>Completed</span>
															<i className="fa-solid fa-chevron-down"></i>
														</a>
														<ul
															className="dropdown-menu black-complete"
															aria-labelledby="dropdownMenuLink"
														>
															<li>
																<Link
																	className="dropdown-item black-complete"
																	to=""
																>
																	All
																</Link>
															</li>
															<li>
																<Link
																	className="dropdown-item black-complete"
																	to=""
																>
																	Pending
																</Link>
															</li>
															<li>
																<Link
																	className="dropdown-item black-complete"
																	to=""
																>
																	In Progress
																</Link>
															</li>
															<li>
																<Link
																	className="dropdown-item black-complete"
																	to=""
																>
																	Complete
																</Link>
															</li>
														</ul>
													</div>
													<div className="d-flex align-items-center gap-1">
														<h4 className="main-heading-font level-6 ">
															Order Type:
														</h4>{" "}
														<h4 className="main-heading-font level-6 ">
															Pickup
														</h4>{" "}
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="row">
										<div className="col-lg-12">
											<h5 class="primary-medium-font level-8 extra-color-10 pe-5 line-height-normal">
												ed ut perspiciatis unde omnis iste natus error sit
												voluptatem accusantium doloremque laudantium, totam rem
												aperiam, eaque ipsa quae ab illo inventore veritatis et
												quasi architecto beatae vitae dicta sunt asdda explicabo
												jackart.
											</h5>
											<div className="mt-4 border-bottom mb-4 pb-4">
												<div class="d-flex align-items-center gap-3 mt-1">
													<h4 class="extra-color-16 level-7">Laudantium</h4>
													<h4 class="extra-color-16 level-7">- X2</h4>
												</div>
												<div class="d-flex align-items-center gap-3 mt-1">
													<h4 class="extra-color-16 level-7">Rem Aperiam</h4>
													<h4 class="extra-color-16 level-7">- X3</h4>
												</div>
												<div class="d-flex align-items-center gap-3 mt-1">
													<h4 class="extra-color-16 level-7">
														Veritatis Et Quasi
													</h4>
													<h4 class="extra-color-16 level-7">- X4</h4>
												</div>
											</div>
											<div className="row">
												<div className="col-lg-12">
													<h4 class="main-heading-font level-6 ">
														Patient Detail
													</h4>
													<div className="d-flex align-items-start gap-3 mt-3">
														<img
															src={patientdetail}
															className="img-fluid mt-2"
															alt=""
														/>
														<div>
															<div class="row mt-3">
																<div class="col-lg-3 mb-2">
																	<h4 class="primary-medium-font level-8 extra-color-10">
																		First Name: John
																	</h4>
																</div>
																<div class="col-lg-3 mb-2">
																	<h4 class="primary-medium-font level-8 extra-color-10">
																		Last Name: Doe
																	</h4>
																</div>
																<div class="col-lg-12 mb-2">
																	<h4 class="primary-medium-font level-8 extra-color-10">
																		phone: +00 123 456 789{" "}
																	</h4>
																</div>
																<div class="col-lg-4"></div>
																<div class="col-lg-12 mb-2">
																	<h4 class="primary-medium-font level-8 extra-color-10">
																		address: 1234 ut perspiciatis, unde omnis
																		iste, natus error sit, voluptatem
																		accusantium, CA, 123456
																	</h4>
																</div>
															</div>
															<div class="row mt-2">
																<div class="col-lg-3 mb-2">
																	<h4 class="primary-medium-font level-8 extra-color-10">
																		City: Baltimore
																	</h4>
																</div>
																<div class="col-lg-3 mb-2">
																	<h4 class="primary-medium-font level-8 extra-color-10">
																		State: Maryland
																	</h4>
																</div>
																<div class="col-lg-3 mb-2">
																	<h4 class="primary-medium-font level-8 extra-color-10">
																		Country: USA
																	</h4>
																</div>
																<div class="col-lg-3 mb-2">
																	<h4 class="primary-medium-font level-8 extra-color-10">
																		Zip Code: 2371
																	</h4>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default PrescriptionOrdersall;
